import { AppEnvironment } from './environment.interface';
import { environment as env } from './environment';

// Re-export with explicit type to help TypeScript across library boundaries
export const environment: AppEnvironment = env;
export * from './environment.interface';
